import { Theme } from '@mui/material';

import MuseoSansCyrl from '@common/assets/MuseoSansCyrl/MuseoSansCyrl-500.woff2';
import MuseoSansCyrlBold from '@common/assets/MuseoSansCyrl/MuseoSansCyrl-700.woff2';

// import authBackgroundBlue from 'assets/authBackgroundBlue.webp';
// import authBackgroundPink from 'assets/authBackgroundPink.webp';

export default {
	styleOverrides: (theme: Theme) => ({
		'@font-face': [
			{
				fontFamily: 'MuseoSansCyrl',
				fontStyle: 'normal',
				fontWeight: 700,
				src: `local('MuseoSansCyrl'), local('MuseoSansCyrl-Bold'), url(${MuseoSansCyrlBold}) format('woff2')`,
			},
			{
				fontFamily: 'MuseoSansCyrl',
				fontStyle: 'normal',
				fontWeight: 500,
				src: `local('MuseoSansCyrl'), local('MuseoSansCyrl-Regular'), url(${MuseoSansCyrl}) format('woff2')`,
			},
		],
		html: {
			minHeight: '100vh',
			height: '100%',
		},
		body: {
			height: '100%',
			minHeight: '100vh',
			background: theme.palette.background.default,
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			backgroundAttachment: 'fixed',
			backgroundPosition: 'center',
			'& #root': {
				height: '100%',
			},
		},
	}),
};
